import { cn } from '@/lib/utils'

const PLAY_PATH =
  'M6.3 2.841A1.5 1.5 0 004 4.11V15.89a1.5 1.5 0 002.3 1.269l9.344-5.89a1.5 1.5 0 000-2.538L6.3 2.84z'

const CAMERA_PATH =
  'M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z'

type VideoPlaySize = 'grid' | 'card' | 'hero' | 'overlay'

const VIDEO_PLAY_SIZES: Record<
  VideoPlaySize,
  { btn: string; icon: string }
> = {
  grid: {
    btn: 'size-5 sm:size-6 md:size-9 lg:size-10',
    icon: 'size-2 sm:size-2.5 md:size-3.5 lg:size-4',
  },
  card: {
    btn: 'size-8 sm:size-9 md:size-10 lg:size-11',
    icon: 'size-3 sm:size-3.5 md:size-4 lg:size-[1.125rem]',
  },
  hero: {
    btn: 'size-9 sm:size-11 md:size-12 lg:size-14',
    icon: 'size-3.5 sm:size-4 md:size-5 lg:size-6',
  },
  overlay: {
    btn: 'size-7 sm:size-8 md:size-10 lg:size-11',
    icon: 'size-3 sm:size-3.5 md:size-4 lg:size-[1.125rem]',
  },
}

interface VideoPlayOverlayProps {
  size?: VideoPlaySize
  className?: string
}

/** Video küçük resim — light: kırmızı düğme; dark: beyaz düğme (globals.css) */
export function VideoPlayOverlay({ size = 'grid', className }: VideoPlayOverlayProps) {
  const s = VIDEO_PLAY_SIZES[size]

  return (
    <>
      <div className="video-play-overlay-dim pointer-events-none absolute inset-0" aria-hidden />
      <div
        className="pointer-events-none absolute inset-0 flex items-center justify-center"
        aria-hidden
      >
        <span
          className={cn(
            'video-play-overlay-btn flex items-center justify-center rounded-full transition-transform motion-safe:duration-300 [@media(hover:hover)_and_(pointer:fine)]:group-hover:scale-110',
            s.btn,
            className,
          )}
        >
          <svg
            className={cn('video-play-overlay-icon ml-0.5', s.icon)}
            fill="currentColor"
            viewBox="0 0 20 20"
            aria-hidden
          >
            <path d={PLAY_PATH} />
          </svg>
        </span>
      </div>
    </>
  )
}

interface GalleryCountBadgeProps {
  count: number | string
  className?: string
}

/** Foto galeri — tüm grid/slider kartlarında aynı rozet */
export function GalleryCountBadge({ count, className }: GalleryCountBadgeProps) {
  return (
    <div
      className={cn(
        'gallery-count-badge absolute z-10 flex items-center gap-0.5 rounded-lg px-1.5 py-0.5 text-[10px] font-bold sm:gap-1 sm:px-2 sm:py-1 sm:text-xs',
        'right-1 top-1 md:right-2 md:top-2',
        className,
      )}
    >
      <svg
        className="gallery-count-badge-icon size-3 shrink-0 sm:size-3.5"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        aria-hidden
      >
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={CAMERA_PATH} />
      </svg>
      <span>{count}+</span>
    </div>
  )
}
